import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/icons/empty-state-chart.tsx
function n(n) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 126 130",
		fill: "var(--color-system-blue-50, #eff6ff)",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": "true",
		focusable: "false",
		...n,
		children: [
			/* @__PURE__ */ e("rect", {
				x: "16",
				y: "92.4167",
				width: "7.83333",
				height: "18.8",
				rx: "3.91667"
			}),
			/* @__PURE__ */ e("rect", {
				x: "33.2333",
				y: "72.05",
				width: "7.83333",
				height: "39.1667",
				rx: "3.91667"
			}),
			/* @__PURE__ */ e("rect", {
				x: "50.4667",
				y: "92.4167",
				width: "7.83333",
				height: "18.8",
				rx: "3.91667"
			}),
			/* @__PURE__ */ e("rect", {
				x: "67.7",
				y: "76.75",
				width: "7.83333",
				height: "34.4667",
				rx: "3.91667"
			}),
			/* @__PURE__ */ e("rect", {
				x: "84.9333",
				y: "65.7834",
				width: "7.83333",
				height: "45.4333",
				rx: "3.91667"
			}),
			/* @__PURE__ */ e("rect", {
				x: "102.167",
				y: "72.05",
				width: "7.83333",
				height: "39.1667",
				rx: "3.91667"
			})
		]
	});
}
//#endregion
export { n as EmptyStateChartIcon };
